var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame109(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 19,
    viewBox: "0 0 44 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 4C40.8954 4 40 3.10457 40 2V2C40 0.89543 39.1046 0 38 0H2C0.895431 0 0 0.895431 0 2V17C0 18.1046 0.895431 19 2 19L38 19C39.1046 19 40 18.1046 40 17V16C40 14.8954 40.8954 14 42 14V14C43.1046 14 44 13.1046 44 12V6C44 4.89543 43.1046 4 42 4V4Z",
    fill: "#4D4D4D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 15,
    rx: 3,
    fill: "#191919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 2C32.6569 2 34 3.34315 34 5L34 14C34 15.6569 32.6569 17 31 17L5 17C3.34315 17 2 15.6569 2 14L2 5C2 3.34314 3.34315 2 5 2L31 2Z",
    fill: "#F8ED33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame109);
export default __webpack_public_path__ + "static/media/Frame 109.473770cb9cff8dd595255c4f617feb51.svg";
export { ForwardRef as ReactComponent };